import {
  Flex,
  useDisclosure,
  Box,
  position,
  useColorMode,
  Menu,
  MenuList,
  IconButton,
  MenuButton,
  Heading,
  MenuItem,
  MenuGroup,
} from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { IoIosContact, IoMdExit } from "react-icons/io";
import { signOut } from "firebase/auth";
import { auth } from "api/firebase/firebaseConfig";
import { NavLink, useNavigate } from "react-router-dom";
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
import { userState } from "states/recoil";
import axios from "axios";
import { panelAtom } from "states/recoil";

const Navbar = () => {
  const user = useRecoilValue(userState);
  const [userLoaded, setUserLoaded] = useState(false);

  const setUserState = useSetRecoilState(userState);
  const { colorMode } = useColorMode();
  const [open, setOpen] = useState(false);
  const [state, setState] = useState({
    left: false,
  });
  const resetPanelState = useResetRecoilState(panelAtom);

  const navigate = useNavigate();
  console.log(auth.currentUser);

  useEffect(() => {
    if (user && user.name) {
      setUserLoaded(true);
    }
  }, [user]);

  const handleLogout = async () => {
    try {
      // Sign out from Firebase
      await signOut(auth);

      // Remove local data
      localStorage.removeItem("sessionToken");
      localStorage.removeItem("userInfo");

      // Reset Recoil user state
      setUserState({
        email: null,
        level: null,
        uid: null,
        province: null,
        isAuthenticated: false,
      });

      resetPanelState();
      // Navigate to login or reload
      navigate("/signin"); // Better UX than reload

      console.log("Signed out successfully");
    } catch (error) {
      console.error("Error during sign out:", error);
    }
  };

  const handleOpenNavbar = () => {
    setOpen((prev) => !prev);
  };

  function formatName(str) {
    return str
      .replace(/-/g, " ") // change "-" to space
      .replace(/\s+/g, " ") // remove extra spaces
      .trim()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }

  return (
    <Box
      w={"100%"}
      minHeight={"70px"}
      borderRadius={"10px"}
      display={"inline-flex"}
      alignItems={"center"}
      px={"12px"}
      textAlign={"space-between"}
      float={"right"}
      justifyContent={"space-between"}
      backgroundColor={colorMode === "light" ? "#ffffff" : "#2D3748"}
      boxShadow={"0 2px 4px rgba(0, 0, 0, 0.1)"}
      color={colorMode === "dark" ? "gray.100" : "gray.800"}
      border="1px solid"
      borderColor="#E2E8F0"
    >
      <Heading
        size={"md"}
        color={colorMode === "dark" ? "gray.100" : "gray.800"}
        textAlign={"left"}
      >
        Dashboard Pemantauan Penyaluran Dana Papua
      </Heading>
      <Menu>
        <MenuButton
          as={IconButton}
          aria-label="Options"
          icon={<IoIosContact fontSize={"32px"} />}
          variant="outline"
        />
        <MenuList pr={4} zIndex={9999}>
          <MenuGroup
            title={
              <Heading size="md" fontWeight="bold" textAlign={"left"}>
                {!userLoaded ? "Memuat..." : formatName(user?.name)}
              </Heading>
            }
          />
          <MenuGroup
            title={
              <Heading size={"sm"} fontWeight={"seminbold"} textAlign={"left"}>
                {!userLoaded ? "Memuat..." : `${formatName(user.level)} `}
              </Heading>
            }
          />
          <MenuGroup
            title={
              <Heading size={"sm"} fontWeight={"seminbold"} textAlign={"left"}>
                {!userLoaded ? "Memuat..." : `${formatName(user.province)} `}
              </Heading>
            }
          />
          <br></br>
          <hr />
          <MenuItem icon={<IoMdExit />} onClick={handleLogout}>
            Logout
          </MenuItem>
        </MenuList>
      </Menu>
    </Box>
  );
};

export default Navbar;
